window.addEventListener("load", function () {
   window.setTimeout(function () {
    $(".page-loader-section").hide();
     $(".shopify-section").show();
    }, 100);
  function MatchHeight() {
  $(".equalheight").matchHeight();
  $(".equalheight1").matchHeight();
  $( ".multicolumn-list__wrapper .multicolumn-card__info .subtitle" ).matchHeight();
  $(".article-card-row__header h2").matchHeight();
   $(".collection-product-card .card__title").matchHeight();
       $(".collection-product-card .caption-with-letter-spacing").matchHeight();
       $(".collection-product-card .product-size").matchHeight();
 $(".collapsible-content__item .collapsible-content__toggle").matchHeight();
   window.setTimeout(function () {
     $(".collection-product-card .card__title").matchHeight();
         $(".collection-product-card .caption-with-letter-spacing").matchHeight();
         $(".collection-product-card .product-size").matchHeight();
    }, 1000);
}
MatchHeight();
});
$(window).on( "scroll", function() {
  var n_check = 0;
  if(jQuery(".product-recommendations ul.product-recommendations__list").length && n_check!=1)
  {
    var n_check = 1;
     $(".collection-product-card .card__title").matchHeight();
     $(".collection-product-card .caption-with-letter-spacing").matchHeight();
     $(".collection-product-card .product-size").matchHeight();
  }
} );
$(document).ready(function () {
  //jQuery("body.body-template-product nav.header__inline-menu a[aria-label='ARTWORKS'] span").addClass("header__active-menu-item");
  $("#ContactForm-phone, .globo-form-control input[data-type='phone']").keypress(function (e) {      
    var charCode = (e.which) ? e.which : event.keyCode    
    if (String.fromCharCode(charCode).match(/[^0-9]/g))    
        return false;                        
    });
  var $temp = $("<input>");
  var $url = $(location).attr('href');
  
  $('.copy-btn').on('click', function() {
    $("body").append($temp);
    $url = $(this).attr("data-href");
    $temp.val($url).select();
    document.execCommand("copy");
    $temp.remove();
    alert("URL cpoied!")
  })
  if (jQuery("#NewsletterPopupModal-popup").length) {
    window.setTimeout(function () {
      if (window.localStorage) {
        // Get the expiration date of the previous popup.
        var nextPopup = localStorage.getItem("nextNewsletterPopup");

        if (nextPopup > new Date() && window.location.hash != "#newsletter-form-popup") {
          return;
        }

        // Store the expiration date of the current popup in localStorage.
        var expires = new Date();
        expires = expires.setHours(expires.getHours() + 24);

        localStorage.setItem("nextNewsletterPopup", expires);
      }
      jQuery("#NewsletterPopupModal-popup").attr("open", "open");
      jQuery("body").addClass("overflow-hidden");
    }, 1000);
  }
  jQuery("details-modal.header__search summary.header__icon--search, .menu-drawer-container summary.header__icon--menu[aria-expanded='false']").click(function(e){
    window.setTimeout(function () {
        jQuery("div.shopify-section-header").addClass("shopify-section-header-sticky animate");
    }, 10);
  });
  jQuery(".menu-drawer-container summary.header__icon--menu[aria-expanded='true']").click(function(){
    window.setTimeout(function () {
    jQuery("div.shopify-section-header").removeClass("shopify-section-header-sticky animate");
    }, 10);
  });
  jQuery(".close-anouncebar").click(function () {
    jQuery(this).parent().hide();
  });
  jQuery(".main-blog .js-load-more").on("click",function(){
    window.setTimeout(function () {
      jQuery(".article-card-row__header h2").matchHeight();
    }, 1000);
  });
  jQuery(".footer-expand-section span").click(function () {
    jQuery(this)
      .parent()
      .parent()
      .find(".footer-block__details-content li.hide-menu")
      .show();
    jQuery(this).parent().hide();
  });
  
  //initialize swiper when document ready
  var mySwiper = new Swiper(".home-slider", {
    // Optional parameters
    direction: "horizontal",
    loop: true,
    speed: 1000,

    navigation: {
      nextEl: ".swiper-btn--next",
      prevEl: ".swiper-btn--prev",
    },
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },

    mousewheelControl: true,
    keyboardControl: true,
    observer: true,
  });
});

var mySwiper = new Swiper(".event-slider-simple", {
  loop: true,
  loopAdditionalSlides: 3,
  autoplay: true,
  speed: 1000,
  parallax: true,
  slidesPerView: 1,
  watchSlidesProgress: true,
  centeredSlides: true,
  navigation: {
    nextEl: ".swiper-btn--next",
    prevEl: ".swiper-btn--prev",
  },
  breakpoints: {
    768: {
      direction: "horizontal",
      slidesPerView: 1,
    },
  },
  on: {
    imagesReady: function () {
      this.el.classList.remove("loading");
    },
  },
});

var swiper = new Swiper(".past-swiper-event", {
  effect: "coverflow",
  grabCursor: true,
  centeredSlides: true,
  coverflowEffect: {
    rotate: 0,
    stretch: 0,
    depth: 150,
    modifier: 2,
    slideShadows: true,
  },
  keyboard: {
    enabled: true,
  },
  mousewheel: {
    thresholdDelta: 70,
  },
  loop: true,
  navigation: {
    nextEl: ".swiper-btn--next",
    prevEl: ".swiper-btn--prev",
  },
  breakpoints: {
    640: {
      slidesPerView: 2,
    },
    768: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 2,
    },
    1280: {
      slidesPerView: 3,
    },
  },
});
$(document).ready(function () {
  jQuery(".collapsible-content__toggle").click(function () {
    jQuery(this).parent().toggleClass("active");
  });

});
var swiper = new Swiper(".mySwiper", {
  direction: "vertical",
  slidesPerView: "auto",
  freeMode: true,
  scrollbar: {
    el: ".swiper-scrollbar",
    draggable: true,
  },
  mousewheel: true,
});
   $('.collection-slider').slick({
        dots: false,
        infinite: false,
       variableWidth: true,
        slidesToScroll: 1,
      slidesToShow: 9,            focusOnSelect: false,
        autoplay: false,
        autoplaySpeed: 2000,
        arrows: true,
         responsive: [
           {
          breakpoint: 1400,
          settings: {
          slidesToShow: 5,
          }
        },
                      {
          breakpoint: 1200,
          settings: {
          slidesToShow: 5,
          }
        },
        {
           breakpoint: 575,
           settings: {
            
           slidesToShow: 2,
                
           }
        }]
    });

